import { FreeTrialGuard } from "./FreeTrialGuard";

export default FreeTrialGuard;
